module.exports = __webpack_public_path__ + "./img/notifications.9357a32b8179d34ff4b928b41056cbf9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/notifications.png
// module id = ./assets/images/notifications.png
// module chunks = 0